import {changeEvent} from "../../../../../webpack/modules/events";
import {updateButtonsPrice} from "../../../../../webpack/modules-optimized/cart";

changeEvent('#product-popup input[name="glass-reversed"]', true, function(element) {
    let container = element.closest('.product-scope');

    updateButtonsPrice(container);
});